module.exports = __webpack_public_path__ + "static/media/aliyasen.33a99fe5.jpeg";